import {
  Component,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { SelectOption } from '../../../models/adminmanagement/AdminRole';
import { HttpErrorResponse } from '@angular/common/http';
import { PensionermanagementService } from '../../../services/pensionermanagement/pensionermanagement.service';
import { AlertService } from '../../../services/shared/alert.service';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import {
  PensionType,
  PPAInfo,
} from '../../../models/pensionermanagement/Pensioner';
import { DataStorageService } from '../../../services/shared/data-storage.service';
import { PensionTypeListResponse } from '../../../models/data-store.model';
import { CashoutManagementService } from '../../../services/cashoutmanagement/cashoutmanagement.service';

@Component({
  selector: 'app-ppa-no-box',
  templateUrl: './ppa-no-box.component.html',
  styleUrl: './ppa-no-box.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PPANoBoxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PPANoBoxComponent),
      multi: true,
    },
  ],
})
export class PPANoBoxComponent
  implements Validator, OnInit, ControlValueAccessor, OnChanges
{
  @Input() showTypeChangeAlert = false;
  @Input() skeletonLoading = false;
  @Input() disabled = false;
  @Input() label = 'Pension Number';
  @Input() pensionType: PensionType = 'civil';
  @Output() pensionTypeChange = new EventEmitter<PensionType>();

  currentYear: string = String(new Date().getFullYear());
  previousYear: string = String(Number(this.currentYear) - 1);

  prefixPolitical: SelectOption[] = [];
  originalDivisionCodes: SelectOption[] = [];
  temporaryDivisionCodes: SelectOption[] = [];
  originalPrefixPoliceAndAffair: SelectOption[] = [];
  temporaryPrefixPoliceAndAffair: SelectOption[] = [];

  oldNewDropdown: SelectOption[] = [
    {
      Value: '0',
      Label: 'Old',
      Parent: '',
    },
    {
      Value: '1',
      Label: 'New',
      Parent: '',
    },
  ];

  perviousPensionType: PensionType = 'civil';
  ppaNumber = new PPAInfo();
  PPADivisionList: any;
  ngControl: NgControl | null = null;
  tempPrefixPoliceAndAffair: any[] = [];

  constructor(
    private injector: Injector,
    private errorHandler: ErrorHandlerService,
    private router: Router,
    private alertService: AlertService,
    private pensionerService: PensionermanagementService,
    private dataStorageService: DataStorageService, private cashoutManagementService: CashoutManagementService
  ) {}

  ngOnInit(): void {

    this.ngControl = this.injector.get(NgControl, null);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
    this.getAllPensionBoxData();
    // this.searchPensioner();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pensionType']) {
      if (
        this.pensionType !== this.perviousPensionType &&
        this.showTypeChangeAlert
      ) {
        this.changingPPAType(this.pensionType);
      }
    }
  }
  
  searchPensioner(): void {
    this.cashoutManagementService.getPensionTypeDataApi().subscribe(
      (res: any) => {
        if (res.StatusCode === '000') {
          this.PPADivisionList = res.Result;
        }
        else {
          this.alertService
            .showError(res.Message)
            .then((result) => {
            });
        }
      },
      (err: HttpErrorResponse) => {
        this.alertService
            .Error('Your session has expired. Please log in again.')
            .then(() => {
              this.router.navigate(['/login']);
            });
      }
    );
  } 
    
  get isRequired(): boolean {
    const validator = this.ngControl?.control?.validator;
    if (!validator) return false;

    const test = validator({} as AbstractControl);
    return test?.['required'] === true;
  }

  get isFormatBox(): boolean {
    // const isFormat =
    //   this.pensionType === 'civil' ||
    //   this.pensionType === 'political' ||
    //   this.pensionType === 'police';
    const isFormat = this.ppaNumber.PPAOldOrNew == '1' ? true : false;
    return isFormat;
  }
  get shouldShowError(): boolean {
    const control = this.ngControl?.control;
    return !!control?.errors?.['required'] && control?.touched;
  }

  oldNewChange(){
    console.log('ppaNumber.PPAOldOrNew', this.ppaNumber.PPAOldOrNew)
  }
  // oldNewChange() {
  //   if (this.pensionType === 'political') {
  //     this.temporaryPrefixPoliceAndAffair = this.prefixPolitical;
  //   } else {
  //     this.temporaryPrefixPoliceAndAffair =
  //       this.originalPrefixPoliceAndAffair.filter(
  //         (item) => item.Parent === this.ppaNumber.PPAOldOrNew
  //       );
  //   }

  //   const allowedParents = [this.ppaNumber.PPAOldOrNew, '2'];

  //   this.temporaryDivisionCodes = this.originalDivisionCodes.filter((item) =>
  //     allowedParents.includes(item.Parent)
  //   );
  //   // this.ppaNumber.DataFileld1 = '';
  // }

  // #region ng modal function
  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.ppaNumber) {
      return { required: true };
    }
    return null;
  }

  onChange = (_: any) => {};

  onTouched = () => {};

  writeValue(value: PPAInfo): void {
    if (value) {
      this.ppaNumber = value;
      this.oldNewChange();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateField(): void {
    this.valueMerge();
    this.onTouched();
    this.onChange(this.ppaNumber);
  }
  // #endregion

  valueMerge() {
    const haveData = this.checkAllDataHaveValue();
    if (haveData.all) {
      this.ppaNumber.PPANumber = this.returnCivilPensoinNumberMergeValue();
    }
  }

  changingPPAType(type: PensionType): void {
    const haveData = this.checkAllDataHaveValue();

    if (haveData.any || this.stringCheck(this.ppaNumber.PPANumber)) {
      this.alertService
        .confirm(
          'Changing the pension type will erase your current inputs. Confirm to proceed?'
        )
        .then((result) => {
          if (result.isConfirmed) {
            this.ppaNumber = new PPAInfo();
            this.perviousPensionType = type;
            // if (type === 'political') {
            //   this.temporaryPrefixPoliceAndAffair = this.prefixPolitical;
            // } else {
            //   this.temporaryPrefixPoliceAndAffair =
            //     this.originalPrefixPoliceAndAffair;
            // }
          } else {
            this.pensionType = this.perviousPensionType;
            this.pensionTypeChange.emit(this.pensionType);
          }
        })
        .catch((error) => {
          console.error('Error during confirmation on type change:', error);
        });
    } else {
      this.perviousPensionType = type;
      this.ppaNumber.PPANoType = type;

      if (type === 'political') {
        this.temporaryPrefixPoliceAndAffair = this.prefixPolitical;
      } else {
        this.temporaryPrefixPoliceAndAffair =
          this.originalPrefixPoliceAndAffair;
      }
    }
  }

  setValueDataField5(value: string) {
    this.ppaNumber.DataFileld5 =
      this.stringCheck(value) && value.length === 4
        ? String(Number(value) + 1)
        : '';
  }

  stringCheck(value: any): boolean {
    return typeof value === 'string' && value.trim() !== '';
  }

  disableField(periviousValue: string): boolean {
    // disable က false ဖြစ်ပြီး value မရှိရင် true ပြန်
    return Boolean(this.disabled || !this.stringCheck(periviousValue));
  }

  checkAllDataHaveValue(): { any: boolean; all: boolean } {
    const fieldsToCheck = [
      this.ppaNumber.DataFileld1,
      this.ppaNumber.DataFileld2,
      this.ppaNumber.DataFileld3,
      this.ppaNumber.DataFileld4,
      this.ppaNumber.DataFileld5,
      // this.ppaNumber.PPANumber,
    ];

    const checked = fieldsToCheck.map((val) => this.stringCheck(val));

    const all = checked.every(Boolean);
    const any = checked.some(Boolean);

    return { any, all };
  }

  returnCivilPensoinNumberMergeValue(): string {
    return (
      this.ppaNumber.DataFileld1 +
      this.ppaNumber.DataFileld2 +
      this.ppaNumber.DataFileld3 +
      '(' +
      this.ppaNumber.DataFileld4 +
      '-' +
      this.ppaNumber.DataFileld5 +
      ')'
    );
  }

  // returnDefesePensionNumberMergeValue(): string {
  //   return (
  //     this.ppaNumber.DataFileld1 +
  //     '(' +
  //     this.ppaNumber.DataFileld2 +
  //     '/' +
  //     this.ppaNumber.DataFileld3 +
  //     ')အပိုင်း(' +
  //     this.ppaNumber.DataFileld4 +
  //     ')' +
  //     'အမှတ်စဉ်(' +
  //     this.ppaNumber.DataFileld5 +
  //     ')'
  //   );
  // }

  // #region Api Call
  getAllPensionBoxData = async () => {
    const pensionDataResponse = await this.dataStorageService.getPensionData();
    if (pensionDataResponse) {
      this.temporaryPrefixPoliceAndAffair = pensionDataResponse.PrefixPoliceAndAffair;
      this.prefixPolitical = pensionDataResponse.PrefixPolitical;
      this.originalDivisionCodes = pensionDataResponse.DivisionCodes;
      this.originalPrefixPoliceAndAffair = pensionDataResponse.PrefixPoliceAndAffair;
    }
    // this.temporaryPrefixPoliceAndAffair = this.originalPrefixPoliceAndAffair;

    this.oldNewChange();
  };

  // #endregion
}
